import { useState } from "react";
import { cn } from "@/lib/cn";

const COVER_BOX = "relative aspect-[16/10] overflow-hidden bg-fog";
const CARD_COVER_STRIPE =
  "bg-[repeating-linear-gradient(-45deg,transparent,transparent_8px,rgba(10,10,10,0.03)_8px,rgba(10,10,10,0.03)_9px)]";

function CoverPlaceholder({
  name,
  className,
  decorative = false,
  stripeClass = CARD_COVER_STRIPE,
}: {
  name: string;
  className?: string;
  decorative?: boolean;
  stripeClass?: string;
}) {
  return (
    <div
      className={cn(COVER_BOX, className)}
      {...(decorative ? { "aria-hidden": true } : { role: "img", "aria-label": name })}
    >
      <div className={cn("absolute inset-0", stripeClass)} />
    </div>
  );
}

interface CoverImageProps {
  src?: string | null;
  name: string;
  decorative?: boolean;
  className?: string;
  stripeClass?: string;
  loading?: "eager" | "lazy";
}

function CoverImage(props: CoverImageProps) {
  return <CoverImageSource key={props.src} {...props} />;
}

function CoverImageSource({
  src,
  name,
  decorative = false,
  className,
  stripeClass,
  loading,
}: CoverImageProps) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <CoverPlaceholder
        name={name}
        decorative={decorative}
        className={className}
        stripeClass={stripeClass}
      />
    );
  }

  return (
    <div className={cn(COVER_BOX, className)}>
      <img
        src={src}
        alt={decorative ? "" : name}
        aria-hidden={decorative || undefined}
        loading={loading}
        className="block size-full object-cover"
        onError={() => setFailed(true)}
      />
    </div>
  );
}

export { CoverImage, CoverPlaceholder };
